import React, { Component } from 'react';
import PropTypes from 'prop-types';

import displayName from 'component-lib/displayName';

import ArrowLeftIcon from '../../Icons/ArrowLeftIcon';
import ArrowRightIcon from '../../Icons/ArrowRightIcon';
import ArrowDoubleLeftIcon from '../../Icons/ArrowDoubleLeftIcon';
import ArrowDoubleRightIcon from '../../Icons/ArrowDoubleRightIcon';

import styles from '../Datepicker.scss';

export default class DatepickerHeader extends Component {
    static displayName = displayName('Widgets/Datepicker/Header');

    static propTypes = {
        currentDate: PropTypes.object.isRequired,
        dateFormat: PropTypes.string.isRequired,
        onPreviousMonth: PropTypes.func.isRequired,
        onNextMonth: PropTypes.func.isRequired,
        onPreviousYear: PropTypes.func.isRequired,
        onNextYear: PropTypes.func.isRequired,
        arrowsVisibility: PropTypes.shape({
            isPrevArrowsVisible: PropTypes.bool,
            isNextArrowsVisible: PropTypes.bool,
        }),
    };

    static defaultProps = {
        arrowsVisibility: {},
    };

    renderPrevNavigations() {
        let navigations = null;

        if (this.props.arrowsVisibility.isPrevArrowsVisible) {
            navigations = (
                <data>
                    <ArrowLeftIcon
                        className={styles['prev-month']}
                        data-action="prev-month"
                        onClick={this.props.onPreviousMonth}
                    />
                    <ArrowDoubleLeftIcon
                        className={styles['prev-year']}
                        data-action="prev-year"
                        onClick={this.props.onPreviousYear}
                    />
                </data>
            );
        }

        return navigations;
    }

    renderNextNavigations() {
        let navigations = null;

        if (this.props.arrowsVisibility.isNextArrowsVisible) {
            navigations = (
                <data>
                    <ArrowRightIcon
                        className={styles['next-month']}
                        data-action="next-month"
                        onClick={this.props.onNextMonth}
                    />

                    <ArrowDoubleRightIcon
                        className={styles['next-year']}
                        data-action="next-year"
                        onClick={this.props.onNextYear}
                    />
                </data>
            );
        }

        return navigations;
    }

    render() {
        return (
            <div className={styles['datepicker-block']}>
                {this.renderPrevNavigations()}

                <data className={styles['header-date']}>
                    {this.props.currentDate.format(this.props.dateFormat)}
                </data>

                {this.renderNextNavigations()}
            </div>
        );
    }
}
